import React, { useEffect, useState } from "react";
import SystemManagerFormContainer from "../SystemManagerFormContainer";
import { configFm } from "../../../types";
import apiServices from "../../../service";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import OverlayLoader from "../../../components/OverlayLoader";
import ContentLoader from "../../../components/Loader/ContentLoader";
import { getCommissionRulesList } from "../../../redux/SystemManager/commissionRules";

function CommissionRule({ notify }: any) {
  const dispatch: AppDispatch = useDispatch();

  const [formContext, setFormContext] = useState("COMMISSION_RULES");
  const [configForm, setConfigForm] = useState<configFm>();
  const [listDataItems, setListDataItems] = useState([]);
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const commissionRules = useSelector(
    (state: RootState) => state.commissionRules
  );

  const [isLoading, setIsLoading] = useState(false);
  const fetchCommissionRuleList = async () => {
    setIsLoading(true);
    try {
      await dispatch(
        getCommissionRulesList({ page: 1, limit: 10, search: "" })
      );
    } catch (err) {
      console.error("Error fetching CommissionRule:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCommissionRuleList();
  }, [dispatch]);

  useEffect(() => {
    if (
      formContext &&
      formSettingsObj?.systemAdmin &&
      formSettingsObj.systemAdmin.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.systemAdmin.formConfig.find(
        (item: any) => item.context === formContext
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);

  return isLoading ? (
    <ContentLoader />
  ) : (
    <div className="">
      <SystemManagerFormContainer
        context={formContext}
        config={configForm}
        notify={notify}
        title=""
        isFormAdmin={true}
        dataList={commissionRules.list}
        reloadData={() => fetchCommissionRuleList()}
      />
    </div>
  );
}

export default CommissionRule;
